transformations = {
    "meta.publicationtype": {
        "operator": "Instructions",
        "eservices": "E-Services Instructions"
    },
    "meta.productcategory": {
        "seeding": "Seeding",
        "tillage": "Tillage",
        "planting": "Planting"
    },
    "meta.productfamily": {
        "swift": "Swift",
        "cultus": "Cultus",
        "opus": "Opus",
        "carrier": "Carrier",
        "carrierXL": "Carrier XL",
        "carrierXT": "Carrier XT",
        "topdown": "TopDown",
        "nzmounted": "NZ mounted",
        "nzaggressive": "NZ Aggressive",
        "nzextreme": "NZ Extreme",
        "rollex": "Rollex",
        "rexius": "Rexius",
        "willrich": "Will-Rich",
        "wishek": "Wishek",
        "ferox": "Ferox",
        "rapid": "Rapid",
        "rapid a": "Rapid A",
        "spirit r": "Spirit R",
        "spirit": "Spirit",
        "inspire": "Inspire",
        "seedhawk": "Seed Hawk",
        "biodrill": "BioDrill",
        "aircarts": "Air Carts",
        "tempo r": "Tempo R",
        "tempo t": "Tempo T",
        "tempo F": "Tempo F",
        "tempo v": "Tempo V",
        "tempo k": "Tempo K",
        "tempo l": "Tempo L",
        "proceed v": "Proceed V",
        "fronthopper": "Front Hopper",
        "tempo r,tempo t,tempo F,tempo v,tempo l,fronthopper": "Tempo R, Tempo T, Tempo F, Tempo V, Tempo L, Front Hopper",
        "tempo F,tempo v,tempo k,tempo l,proceed v,fronthopper": "Tempo F, Tempo V, Tempo K, Tempo L, Proceed V, Front Hopper",
        "spirit r,spirit": "Spirit R, Spirit",
        "fronthopper,proceed v,tempo F,tempo k,tempo l,tempo v": "Front Hopper, Proceed V, Tempo F, Tempo K, Tempo L, Tempo V",
        "fronthopper,tempo F,tempo l,tempo r,tempo t,tempo v": " Front Hopper, Tempo F, Tempo L, Tempo R, Tempo T, Tempo V",
        "opus,topdown": "Opus, TopDown"
    }
};

//# sourceMappingURL=se.simonsoft.vab.pilot.0aa85614.js.map
